import React from 'react';
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from "@mui/material/IconButton";
import {ListItemButton, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";

const MessageItem = ({item,settingMenuCallback}) => {
    const navigate = useNavigate();
    const onopenorder = () => {
        // alert(index.id);
        settingMenuCallback();
        navigate('/detailsmessage/' + item.id);
        // navigate('/ticketdetails/' + x)
    }

    return (
        <ListItemButton component={"li"} disableRipple onClick={onopenorder}>
            <ListItemAvatar>
                <Avatar src={item.user.profile_pic}/>
            </ListItemAvatar>
            <ListItemText primary={<Typography style={{fontFamily: 'Iran'}} variant={"h6"} mb={.25}>{item.Title}</Typography>}
                          secondary={<Typography style={{fontFamily: 'Iran'}} noWrap color={"text.secondary"}>{item.Body}</Typography>}
            />
            {/*<IconButton elevation={1} edge={"end"} size={"small"}><MoreHorizIcon/></IconButton>*/}
        </ListItemButton>
    );
};

export default MessageItem;
